export { default } from './LandingLayout';
